"use client";

import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { styles } from "@repo/helpers";
import * as React from "react";

/**
 * Renders a separator to visually or semantically separates content.
 *
 * Imported from `shadcn`
 */
function Separator({
	className,
	orientation = "horizontal",
	decorative = true,
	...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
	return (
		<SeparatorPrimitive.Root
			data-slot="separator"
			decorative={decorative}
			orientation={orientation}
			className={styles(
				"shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px",
				className,
			)}
			{...props}
		/>
	);
}

export { Separator };
